<template>
  <div class="table-operation">
    <template v-for="(item, oIndex) in operation">
      <button
        v-if="show(item)"
        :key="oIndex"
        class="table-operation-item"
        :type="type(item)"
        :disabled="disabled(item)"
        style="margin: 0 6px; font-size: 12px;"
        @click="handle(item)"
      >
        {{ label(item) }}
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: -1
    },
    // eslint-disable-next-line
    _operation: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    operation() {
      return [...this._operation.operation]
    }
  },
  methods: {
    show(item) {
      const show = typeof item.show === 'function' ? item.show(this.row) : item.show
      return show !== false
    },
    label(item) {
      const label = typeof item.label === 'function' ? item.label(this.row, this.index) : item.label
      return this.$t(label)
    },
    type(item) {
      const type = typeof item.type === 'function' ? item.type(this.row, this.index) : item.type
      return type
    },
    handle(item) {
      if (this.disabled(item)) return
      if (item.handle) {
        item.handle.call(this._operation._list && this._operation._list.vm, this.row, this.index)
      }
      const event = item.event
      const $list = this._operation._list
      if (event && $list && $list[event]) {
        $list[event](this.row, this.index)
      }
    },
    disabled(item) {
      const disabled = typeof item.disabled === 'function' ? item.disabled(this.row) : item.disabled
      return disabled
    }
  }
}
</script>

<style lang="scss" scoped>
.table-operation {
  &-item {
    border: none;
    outline: none;
    background: #ECF1F4;
    color: #008EE3;
    height: 30px;
    padding: 0 15px;
    border-radius: 16px;
    cursor: pointer;
  }
}
</style>
